import { __ } from '@wordpress/i18n';
import { useEffect, useState } from "react";
export const Popup = (props) => {
  const [src, setSrc] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    window.addEventListener("checkoutCompleted", onCheckoutComplete);
    
    return () => {
      window.removeEventListener("checkoutCompleted", onCheckoutComplete);

    };
  }, []);
  useEffect(() => {
    if (src !== "") showModal();
  }, [src]);
  
  const onCheckoutComplete = async (event, data) => {

    const errorCount = document.querySelectorAll(
      ".woocommerce-error li"
    ).length;

    if (errorCount >= 1) {
      document
        .querySelector(".woocommerce-notices-wrapper")
        .innerHTML = "";
    }
    
      let popURL = {
        action: "popup_redirect_url",
      };

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(popURL).toString(),
      };
     
      fetch(sfwp_ajax_object.ajaxurl, options)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text(); // Change this to response.json() if expecting JSON response
        })
        .then((responseBody) => {
          const elem = document.querySelector(".woocommerce-notices-wrapper");
          //woocommerce-NoticeGroup-checkout
          
          if (responseBody !== "" && responseBody !== "no-redirection") {
            setSrc(responseBody);
            if (elem) elem.style.display = "none";
          } else {
            if (elem) elem.style.display = "block";

            return false;
          }
        })

        .catch((error) => console.error(error));
    
  };
  const openModal = (url) => {
    setShowModal(true);
  };
  const showModal = () => {
    
     document.body.classList.add("pop-visible", "sfwp-popup");

    const noticeGroupElem = document.querySelector(
      ".woocommerce-NoticeGroup-checkout"
    );
    if (noticeGroupElem) noticeGroupElem.style.display = "none";
    setIsOpen(true);
  };
  window.openReactModal = openModal;
  const { popupTextTrans } = props;
  const popupText = popupTextTrans;

  return (
    <>
      <div className={`sfwp-pop-bg  ${isOpen ? "open" : ""}`}></div>
      <div
        id="iframe-wrap"
        // className="cc-wrapper"
        className={`cc-wrapper  ${isOpen ? "open" : ""}`}
      >
        <div className="alert-danger">
          <svg
            className="alert-triangle"
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M9.938 4.016a.146.146 0 00-.054.057L3.027 15.74a.176.176 0 00-.002.183c.016.03.037.05.054.06.015.01.034.017.066.017h13.713a.12.12 0 00.066-.017.163.163 0 00.055-.06.176.176 0 00-.003-.183L10.12 4.073a.146.146 0 00-.054-.057.13.13 0 00-.063-.016.13.13 0 00-.064.016zm1.043-.45a1.13 1.13 0 00-1.96 0L2.166 15.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L10.982 3.566z"
              clipRule="evenodd"
            ></path>
            <rect width="2" height="2" x="9.002" y="13" rx="1"></rect>
            <path d="M9.1 7.995a.905.905 0 111.8 0l-.35 3.507a.553.553 0 01-1.1 0L9.1 7.995z"></path>
          </svg>
          <p>
            <b>
             {popupText}
            </b>
          </p>
        </div>
        <iframe
          id="thedialog"
          width="750"
          height="650"
          title="Saferpay"
          src={src}
        ></iframe>
      </div>
    </>
  );
};
